/* ===========================================
   bypirla★ — Flechas card colección: 
   Evitar navegación a PDP al hacer clic
   =========================================== */

document.addEventListener('click', function(e) {
  const arrow = e.target.closest('.card-gallery slideshow-arrows .slideshow-control');
  if (arrow) {
    e.preventDefault();
    e.stopPropagation();
  }
}, true);


/* ===========================================
   bypirla★ — Fallback de autoplay para hero video
   Soluciona video que no autoreproduce (ni con clic)
   al entrar desde el navegador in-app de Instagram
   =========================================== */

(function () {
  'use strict';

  function attachAutoplayFallback(video) {
    if (!video || video.dataset.autoplayFallback) return;
    video.dataset.autoplayFallback = 'true';

    var tryPlay = function () {
      var p = video.play();
      if (p !== undefined) {
        p.catch(function () {
          var retry = function () {
            video.play().catch(function () {});
          };
          document.addEventListener('touchend', retry, { once: true, passive: true });
          document.addEventListener('click', retry, { once: true });
          document.addEventListener('scroll', retry, { once: true, passive: true });
        });
      }
    };

    tryPlay();

    document.addEventListener('visibilitychange', function () {
      if (!document.hidden && video.paused) tryPlay();
    });
  }

  function initHeroVideos() {
    document.querySelectorAll('.hero__video').forEach(attachAutoplayFallback);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeroVideos);
  } else {
    initHeroVideos();
  }
})();


/* ===========================================
   bypirla★ — Fix Marquee (carrusel @bypirla del footer)
   El componente real es <marquee-component>, no slideshow.
   1. Velocidad más rápida en mobile (forzada vía CSS var)
   2. Deslizable con el dedo — solo touch/mobile
   3. Watchdog anti-freeze (bug conocido de Safari/Chrome mobile
      donde las animaciones CSS se cuelgan tras scroll/background)
   =========================================== */

(function () {
  'use strict';

  var MOBILE_BREAKPOINT = 749;
  var MOBILE_DURATION_S = 25;   // duración del loop completo en mobile — bájalo para más rápido
  var REAPPLY_DELAY_MS = 450;   // más que el debounce interno del tema (250ms), para ganarle
  var WATCHDOG_INTERVAL_MS = 4000;

  function isMobile() {
    return window.innerWidth <= MOBILE_BREAKPOINT;
  }

  function getMarquees() {
    return document.querySelectorAll('marquee-component');
  }

  function getWrapper(el) {
    return el.querySelector('.marquee__wrapper');
  }

  // --- FIX 1: forzar velocidad en mobile ---
  function forceMobileSpeed(el) {
    if (!isMobile()) return;
    el.style.setProperty('--marquee-speed', MOBILE_DURATION_S + 's');
  }

  function applySpeedFix() {
    getMarquees().forEach(forceMobileSpeed);
  }

  // --- FIX 3: watchdog anti-freeze ---
  function watchdog() {
    getMarquees().forEach(function (el) {
      if (el.dataset.dragging === 'true') return; // no interferir durante un swipe activo

      var wrapper = getWrapper(el);
      if (!wrapper) return;

      var anim = wrapper.getAnimations()[0];
      if (!anim || document.hidden) return;

      var last = el._wdLastTime;
      var now = anim.currentTime;

      if (anim.playState === 'paused') {
        anim.play();
      } else if (last !== undefined && Math.abs(now - last) < 5) {
        // el tiempo no avanzó entre chequeos: la animación está colgada, forzar reinicio
        anim.currentTime = now + 1;
        anim.play();
      }

      el._wdLastTime = anim.currentTime;
    });
  }

  // --- FIX 2: swipe con el dedo (solo touch) ---
  function enableTouchDrag(el) {
    if (el.dataset.dragEnabled) return;
    el.dataset.dragEnabled = 'true';

    var wrapper = getWrapper(el);
    if (!wrapper) return;

    wrapper.style.touchAction = 'pan-y'; // deja scroll vertical libre, capturamos el horizontal

    var startX = 0;
    var startTime = 0;
    var pxPerMs = null;

    wrapper.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'touch') return; // solo mobile/touch, no afecta desktop

      var anim = wrapper.getAnimations()[0];
      if (!anim) return;

      el.dataset.dragging = 'true';
      startX = e.clientX;
      startTime = anim.currentTime || 0;
      anim.pause();

      // el contenido está duplicado para el loop infinito: la mitad del scrollWidth
      // equivale a un ciclo completo
      var singleSetWidth = wrapper.scrollWidth / 2;
      var durationMs = anim.effect && anim.effect.getTiming().duration;
      if (typeof durationMs !== 'number' || !durationMs) {
        var cssDur = getComputedStyle(el).getPropertyValue('--marquee-speed');
        durationMs = (parseFloat(cssDur) || 10) * 1000;
      }
      pxPerMs = singleSetWidth / durationMs;
    });

    wrapper.addEventListener('pointermove', function (e) {
      if (el.dataset.dragging !== 'true' || pxPerMs === null) return;

      var anim = wrapper.getAnimations()[0];
      if (!anim) return;

      var deltaX = e.clientX - startX;
      var deltaTime = deltaX / pxPerMs;
      var durationMs = anim.effect.getTiming().duration || 1;

      var newTime = startTime - deltaTime;
      newTime = ((newTime % durationMs) + durationMs) % durationMs; // mantener dentro del ciclo

      anim.currentTime = newTime;
    });

    function endDrag() {
      if (el.dataset.dragging !== 'true') return;
      el.dataset.dragging = 'false';
      var anim = wrapper.getAnimations()[0];
      if (anim) anim.play();
    }

    wrapper.addEventListener('pointerup', endDrag);
    wrapper.addEventListener('pointercancel', endDrag);
  }

  function init() {
    getMarquees().forEach(function (el) {
      forceMobileSpeed(el);
      enableTouchDrag(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(applySpeedFix, REAPPLY_DELAY_MS);
  });

  setInterval(watchdog, WATCHDOG_INTERVAL_MS);
})();


/* ===========================================
   bypirla★ — Checkbox de consentimiento de privacidad
   Password page (bloque nativo "Email Signup" de Horizon)
   Se inyecta vía JS para no tocar el bloque nativo del tema.
   Bloquea el envío del formulario hasta que se acepte.
   =========================================== */

(function () {
  'use strict';

  function initPrivacyConsentOnPasswordPage() {
    // Busca el input de email dentro del formulario de la password page
    var emailInput = document.querySelector(
      'main.password-main-content input[type="email"], main.password-main-content input[name*="email"]'
    );
    if (!emailInput) return;

    var form = emailInput.closest('form');
    if (!form || form.dataset.bypirlaConsentInit) return;
    form.dataset.bypirlaConsentInit = 'true';

    var submitBtn = form.querySelector('button[type="submit"], input[type="submit"]');
    if (!submitBtn) return;

    // Crea el bloque de consentimiento
    var consentWrap = document.createElement('div');
    consentWrap.className = 'bypirla-consent';
    consentWrap.style.cssText =
      'display:flex;align-items:flex-start;gap:8px;margin:12px 0;font-size:0.7rem;text-align:left;';
    consentWrap.innerHTML =
      '<input type="checkbox" id="bypirla-privacy-check" required style="margin-top:3px;flex-shrink:0;">' +
      '<label for="bypirla-privacy-check">Acepto la <a href="/policies/privacy-policy" target="_blank" rel="noopener">Política de Privacidad</a> y el tratamiento de mis datos para recibir novedades.</label>';

    // Inserta el checkbox justo antes del botón enviar (dentro de su contenedor)
    submitBtn.parentElement.insertBefore(consentWrap, submitBtn);

    var checkbox = document.getElementById('bypirla-privacy-check');
    submitBtn.disabled = true;
    submitBtn.style.opacity = '0.5';
    submitBtn.style.cursor = 'not-allowed';

    checkbox.addEventListener('change', function () {
      submitBtn.disabled = !checkbox.checked;
      submitBtn.style.opacity = checkbox.checked ? '1' : '0.5';
      submitBtn.style.cursor = checkbox.checked ? 'pointer' : 'not-allowed';
    });

    form.addEventListener('submit', function (e) {
      if (!checkbox.checked) {
        e.preventDefault();
        alert('Debes aceptar la Política de Privacidad para continuar.');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPrivacyConsentOnPasswordPage);
  } else {
    initPrivacyConsentOnPasswordPage();
  }

  // Fallback: el bloque "Email Signup" de Horizon puede renderizar tarde
  // (custom elements / Section Rendering API), así que observamos el DOM
  var consentObserver = new MutationObserver(function () {
    initPrivacyConsentOnPasswordPage();
  });
  consentObserver.observe(document.body, { childList: true, subtree: true });
})();


/* ===========================================
   bypirla★ — Barra de carga en el header (add to cart)
   Intercepta fetch() a rutas de /cart/* (add, update, change)
   y muestra una barra de progreso arriba del header mientras
   dura la request. Cubre botón nativo, cross-sell drawer, y
   cualquier otro punto que le pegue al cart — no requiere
   modificar los handlers existentes.
   =========================================== */

(function () {
  'use strict';

  var BAR_ID = 'bypirla-loading-bar';
  var progressInterval = null;
  var activeRequests = 0;

  function injectStyles() {
    if (document.getElementById('bypirla-loading-bar-styles')) return;
    var style = document.createElement('style');
    style.id = 'bypirla-loading-bar-styles';
    style.textContent =
      '#' + BAR_ID + '{position:fixed;top:0;left:0;height:3px;width:0%;' +
      'background:#F5F0E6;z-index:9999;transition:width .3s ease,opacity .3s ease;' +
      'opacity:0;pointer-events:none;box-shadow:0 0 4px rgba(0,0,0,.25);}' +
      '#' + BAR_ID + '.is-active{opacity:1;}';
    document.head.appendChild(style);
  }

  function getBar() {
    var bar = document.getElementById(BAR_ID);
    if (!bar) {
      bar = document.createElement('div');
      bar.id = BAR_ID;
      document.body.appendChild(bar);
    }
    return bar;
  }

  function startLoadingBar() {
    activeRequests++;
    if (activeRequests > 1) return; // ya hay una barra corriendo, no reiniciar

    injectStyles();
    var bar = getBar();
    bar.style.transition = 'none';
    bar.style.width = '0%';
    bar.classList.add('is-active');
    // eslint-disable-next-line no-unused-expressions
    bar.offsetWidth; // forzar reflow para que la siguiente transición se anime
    bar.style.transition = 'width .3s ease, opacity .3s ease';

    var progress = 0;
    clearInterval(progressInterval);
    progressInterval = setInterval(function () {
      progress += Math.random() * 10;
      if (progress > 90) progress = 90; // se queda esperando a que la request real termine
      bar.style.width = progress + '%';
    }, 150);
  }

  function finishLoadingBar() {
    activeRequests = Math.max(0, activeRequests - 1);
    if (activeRequests > 0) return; // todavía hay otra request de cart en curso

    clearInterval(progressInterval);
    var bar = getBar();
    bar.style.width = '100%';
    setTimeout(function () {
      bar.classList.remove('is-active');
      setTimeout(function () {
        bar.style.width = '0%';
      }, 300);
    }, 150);
  }

  function isCartRequest(input) {
    var url = '';
    if (typeof input === 'string') {
      url = input;
    } else if (input && typeof input.url === 'string') {
      url = input.url; // Request object
    } else if (input && typeof input.toString === 'function') {
      url = input.toString();
    }
    return /\/cart\/(add|update|change)(\.js)?/.test(url);
  }

  function initFetchInterceptor() {
    if (window.fetch.__bypirlaLoadingBarPatched) return;

    var originalFetch = window.fetch;

    var patchedFetch = function (input, init) {
      var trackThis = isCartRequest(input);
      if (trackThis) startLoadingBar();

      return originalFetch.call(this, input, init).then(
        function (response) {
          if (trackThis) finishLoadingBar();
          return response;
        },
        function (error) {
          if (trackThis) finishLoadingBar();
          throw error;
        }
      );
    };

    patchedFetch.__bypirlaLoadingBarPatched = true;
    window.fetch = patchedFetch;
  }

  initFetchInterceptor();
})();


/* ===========================================
   bypirla★ — Fix salto de texto sticky en PDP (desktop)
   NOTA: este fix se movió a layout/theme.liquid como un <style>
   inline dentro del <head>. Así se aplica antes del primer paint,
   sin esperar a que cargue este archivo — evita cualquier salto
   visible al entrar a la página, no solo durante el scroll.
   Para ajustar la altura, editar directo el <style> en theme.liquid.
   =========================================== */


/* ===========================================
   bypirla★ — Reubicar "Ingresar con contraseña"
   El botón original vive en el bloque "Password footer" (oculto vía
   CSS en password.liquid porque ocupaba mucho espacio abajo). Acá lo
   clonamos y lo insertamos justo debajo del bloque de email, alineado
   a la derecha. Es un clone (no un move), así que el original queda
   intacto y oculto en el footer, y este clon conserva el mismo
   on:click="#password-form/showDialog" — el modal de contraseña
   sigue abriendo exactamente igual.
   =========================================== */

(function () {
  'use strict';

  function movePasswordEnterLink() {
    // Anclado a "body > footer" a propósito: sin esto, el selector podía
    // matchear nuestro propio clon (misma clase) una vez insertado, y
    // terminaba clonando el clon en cada mutación → duplicados infinitos.
    var original = document.querySelector('body > footer .password-enter__button');
    if (!original || original.dataset.bypirlaCloned) return;

    // Anclamos al INPUT real de email (no al .email-signup-block por clase,
    // que podría matchear un bloque duplicado/oculto) y subimos al
    // contenedor que ya tiene position:relative + z-index:2 aplicado.
    var emailInput = document.querySelector('.section-password input[type="email"]');
    var emailBlock = emailInput ? emailInput.closest('.section-content-wrapper > *') : null;
    if (!emailBlock || emailBlock.querySelector('.password-enter-inline')) return;

    var wrapper = document.createElement('div');
    wrapper.className = 'password-enter-inline';

    var clone = original.cloneNode(true);
    clone.removeAttribute('id');
    wrapper.appendChild(clone);

    // Insertado ADENTRO del bloque de email (no al lado): hereda su ancho
    // real y queda dentro del mismo contexto de apilamiento ya elevado
    // por encima del video de fondo, sin depender de reglas CSS extra.
    emailBlock.appendChild(wrapper);
    original.dataset.bypirlaCloned = 'true';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', movePasswordEnterLink);
  } else {
    movePasswordEnterLink();
  }

  // Fallback: el bloque de email puede renderizar tarde (Section Rendering API)
  var passwordLinkObserver = new MutationObserver(movePasswordEnterLink);
  passwordLinkObserver.observe(document.body, { childList: true, subtree: true });
})();


/* ===========================================
   bypirla★ — Tope de unidades por talla (PDP)
   El carrito ya respeta el tope con el atributo max del
   selector de cantidad (ver snippets/quantity-selector.liquid),
   pero el botón "Agregar al carrito" del PDP no lo mira:
   pulsándolo dos veces quedaban 2 unidades de la misma talla.
   Acá deshabilitamos el botón cuando la talla seleccionada ya
   alcanzó su tope en el carrito.
   Topes: Accesorios 10 (el límite global de la tienda),
   el resto 1 por talla.
   =========================================== */

(function () {
  'use strict';

  var TIPO_SIN_TOPE = 'Accesorios';
  var TOPE_ACCESORIOS = 10;
  var TOPE_PRENDAS = 1;
  var POLL_MS = 600;

  var productType = null;
  var ultimaVariante = null;

  function getHandle() {
    var m = location.pathname.match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  function getBoton() {
    return document.querySelector('button[name="add"]');
  }

  function getVariante() {
    var input = document.querySelector('input[name="id"]');
    return input ? parseInt(input.value, 10) : null;
  }

  function getTope() {
    return productType === TIPO_SIN_TOPE ? TOPE_ACCESORIOS : TOPE_PRENDAS;
  }

  function getAviso(btn) {
    var aviso = document.getElementById('bp-tope-aviso');
    if (!aviso) {
      aviso = document.createElement('p');
      aviso.id = 'bp-tope-aviso';
      aviso.style.cssText = 'margin:8px 0 0;font-size:0.75rem;opacity:0.7;text-align:center;';
      btn.parentElement.insertBefore(aviso, btn.nextSibling);
    }
    return aviso;
  }

  function actualizar() {
    var btn = getBoton();
    var vid = getVariante();
    if (!btn || !vid || productType === null) return;

    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var enCarrito = cart.items.reduce(function (n, i) {
          return i.variant_id === vid ? n + i.quantity : n;
        }, 0);

        var tope = getTope();
        var aviso = getAviso(btn);

        if (enCarrito >= tope) {
          btn.disabled = true;
          btn.dataset.bpLimited = 'true';
          aviso.textContent =
            tope === 1
              ? 'Máximo 1 por talla — ya está en tu carrito.'
              : 'Alcanzaste el máximo de ' + tope + ' unidades.';
          aviso.style.display = '';
        } else {
          // Solo re-habilitamos lo que deshabilitamos nosotros: si el
          // botón está apagado por falta de stock, no lo tocamos.
          if (btn.dataset.bpLimited === 'true') {
            btn.disabled = false;
            btn.dataset.bpLimited = '';
          }
          aviso.style.display = 'none';
        }
      })
      .catch(function () {});
  }

  function init() {
    var handle = getHandle();
    if (!handle) return;

    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) {
        productType = p.type || '';
        ultimaVariante = getVariante();
        actualizar();
      })
      .catch(function () {});

    document.addEventListener('cart:update', function () {
      setTimeout(actualizar, 350);
    });

    // Al elegir otra talla el tema reescribe input[name="id"] sin emitir
    // un evento propio, así que lo chequeamos con un poll liviano.
    setInterval(function () {
      var vid = getVariante();
      if (vid && vid !== ultimaVariante) {
        ultimaVariante = vid;
        actualizar();
      }
    }, POLL_MS);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


/* ===========================================
   bypirla★ — Aviso al intentar superar el tope (carrito)
   Antes, al llegar al tope, pulsar "+" no hacía absolutamente
   nada: el tema deshabilita el botón (y uno deshabilitado ni
   siquiera emite eventos) o, en el minicart, lo deja activo y
   recorta la cantidad en silencio. Acá cubrimos los dos casos
   y pintamos el aviso en la celda de error que el tema ya trae
   en cada línea, para que salga donde el cliente espera verlo.

   Ojo con el re-pintado: tras el click el tema vuelve a
   renderizar la línea (~1s después) y el morph se llevaba
   puesto el aviso. Por eso no lo escribimos una sola vez, sino
   que lo sostenemos durante unos segundos re-aplicándolo sobre
   la fila (ubicada por su data-key, que sobrevive al morph).
   =========================================== */

(function () {
  'use strict';

  var MENSAJE = 'Debido a la disponibilidad, solo se añadió un artículo al carrito.';
  var VISIBLE_MS = 5000;
  var REPINTAR_MS = 150;
  var STYLE_ID = 'bp-limite-aviso-styles';

  var activo = null;

  function injectStyles() {
    if (document.getElementById(STYLE_ID)) return;
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent =
      // Sin esto, el "+" deshabilitado se traga el click y no hay forma
      // de enterarse de que el cliente lo intentó.
      '.quantity-plus:disabled{pointer-events:none;}' +
      '.cart-items__error.bp-limite .cart-item__error-text{color:#CC0000;font-style:italic;}';
    document.head.appendChild(style);
  }

  function filaPorKey(key) {
    var filas = document.querySelectorAll('[data-key]');
    for (var i = 0; i < filas.length; i++) {
      if (filas[i].getAttribute('data-key') === key && filas[i].querySelector('.cart-items__error')) {
        return filas[i];
      }
    }
    return null;
  }

  function limpiar() {
    if (!activo) return;
    var fila = filaPorKey(activo.key);
    if (fila) {
      var celda = fila.querySelector('.cart-items__error');
      if (celda) {
        celda.classList.add('hidden');
        celda.classList.remove('bp-limite');
      }
    }
    clearInterval(activo.timer);
    activo = null;
  }

  function pintarAviso() {
    if (!activo) return;
    if (Date.now() > activo.hasta) {
      limpiar();
      return;
    }

    var fila = filaPorKey(activo.key);
    if (!fila) return;

    var celda = fila.querySelector('.cart-items__error');
    var texto = celda ? celda.querySelector('.cart-item__error-text') : null;
    if (!celda || !texto) return;

    if (texto.textContent !== MENSAJE) texto.textContent = MENSAJE;
    texto.classList.remove('hidden');
    celda.classList.remove('hidden');
    celda.classList.add('bp-limite');
  }

  function mostrarAviso(plus) {
    var fila = plus.closest('[data-key]');
    var key = fila ? fila.getAttribute('data-key') : null;
    if (!key) return;

    limpiar();
    activo = { key: key, hasta: Date.now() + VISIBLE_MS, timer: null };
    activo.timer = setInterval(pintarAviso, REPINTAR_MS);
    pintarAviso();
  }

  // Un "+" apagado tiene pointer-events:none, así que el click llega al
  // contenedor: lo ubicamos mirando si cayó dentro de su rectángulo.
  function plusEnPunto(x, y) {
    var botones = document.querySelectorAll('.quantity-plus:disabled');
    for (var i = 0; i < botones.length; i++) {
      var r = botones[i].getBoundingClientRect();
      if (x >= r.left && x <= r.right && y >= r.top && y <= r.bottom) {
        return botones[i];
      }
    }
    return null;
  }

  function yaEnElTope(plus) {
    var comp = plus.closest('cart-quantity-selector-component, quantity-selector-component');
    var input = comp ? comp.querySelector('input') : null;
    if (!input) return false;
    var max = parseInt(input.max, 10);
    var valor = parseInt(input.value, 10);
    return !isNaN(max) && !isNaN(valor) && valor >= max;
  }

  document.addEventListener(
    'click',
    function (e) {
      // Caso A: el "+" sigue activo (minicart recién abierto) y el tema
      // va a recortar la cantidad sin decir nada.
      var plus = e.target && e.target.closest ? e.target.closest('.quantity-plus') : null;
      // Caso B: el "+" ya está apagado y el click lo atravesó.
      if (!plus) plus = plusEnPunto(e.clientX, e.clientY);

      if (!plus || !(plus.disabled || yaEnElTope(plus))) return;

      // No dejamos que el componente procese el click: ya está en el tope,
      // así que pegarle al servidor no aporta nada.
      e.preventDefault();
      e.stopPropagation();

      mostrarAviso(plus);
    },
    true
  );

  injectStyles();
})();